import React from "react";
import { FIXED_COUNTRY_CODE, sanitizeMobileDigits } from "../../utils/phone";

/**
 * Single phone field: fixed +91 prefix + 10-digit mobile input.
 * variant "mipl" — rounded border used on accountant / fuel operator / sub-admin forms
 * variant "form" — Bootstrap form-control (driver edit)
 */
const PhoneNumberField = ({
  value = "",
  onChange,
  disabled = false,
  hasError = false,
  placeholder = "10-digit mobile",
  variant = "mipl",
  wrapperClassName = "",
  className = "",
  "aria-label": ariaLabel = "Mobile number",
}) => {
  const handleChange = (e) => {
    onChange?.(sanitizeMobileDigits(e.target.value));
  };

  if (variant === "form") {
    return (
      <div className={`relative ${wrapperClassName} ${className}`}>
        <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-600">
          {FIXED_COUNTRY_CODE}
        </span>
        <input
          type="tel"
          inputMode="numeric"
          maxLength={10}
          placeholder={placeholder}
          className={`form-control pl-12 ${hasError ? "border border-red-500" : ""}`}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          autoComplete="tel"
          aria-label={ariaLabel}
        />
      </div>
    );
  }

  return (
    <div
      className={`flex w-full min-w-0 items-stretch overflow-hidden rounded-3 border-[1px] ${
        hasError ? "border-red-500" : "border-[#0B3E64]"
      } ${wrapperClassName} ${className}`}
    >
      <span
        className="flex shrink-0 items-center border-r border-[#0B3E64]/25 bg-[#f5f8fa] px-3 font-UbuntuMedium text-[#0B3E64]"
        aria-hidden
      >
        {FIXED_COUNTRY_CODE}
      </span>
      <input
        type="tel"
        inputMode="numeric"
        maxLength={10}
        placeholder={placeholder}
        className="min-w-0 flex-1 border-0 bg-transparent px-3 py-0 outline-none h-[44px] md:h-[54px]"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        autoComplete="tel"
        aria-label={ariaLabel}
      />
    </div>
  );
};

export default PhoneNumberField;
